// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"6080eaf7","110":"ab0d76bd","143":"39047d35","205":"955bad72","382":"3de0fad4","481":"c706b2a8","683":"27a68b1a"}[chunkId] + ".chunk.js";
};